"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unregister = exports.register = void 0;
const isLocalhost = Boolean(window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function register(config, appUrl, callback) {
    const fixedAppUrl = appUrl || "/";
    if ("serviceWorker" in navigator) {
        // The URL constructor is available in all browsers that support SW.
        const appUrlClass = new URL(fixedAppUrl, window.location);
        if (appUrlClass.origin !== window.location.origin) {
            // Our service worker won't work if PUBLIC_URL is on a different origin
            // from what our page is served on. This might happen if a CDN is used to
            // serve assets; see https://github.com/facebook/create-react-app/issues/2374
            return;
        }
        window.addEventListener("load", () => {
            const swUrl = `${fixedAppUrl}service-worker.js`;
            if (isLocalhost) {
                // This is running on localhost. Let's check if a service worker still exists or not.
                checkValidServiceWorker(swUrl, callback);
                // Add some additional logging to localhost, pointing developers to the
                // service worker/PWA documentation.
                navigator.serviceWorker.ready.then(() => {
                    // tslint:disable-next-line
                    console.log("This web app is being served cache-first by a service " +
                        "worker. To learn more, visit https://goo.gl/SC7cgQ");
                });
            }
            else {
                // Is not local host. Just register service worker
                registerValidSW(swUrl, callback);
            }
        });
    }
}
exports.register = register;
function registerValidSW(swUrl, callback) {
    navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
        registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker) {
                installingWorker.onstatechange = () => {
                    if (installingWorker.state === "installed") {
                        if (navigator.serviceWorker.controller) {
                            // At this point, the old content will have been purged and
                            // the fresh content will have been added to the cache.
                            // It's the perfect time to display a "New content is
                            // available; please refresh." message in your web app.
                            // tslint:disable-next-line
                            console.log("New content is available; please refresh.");
                            // Execute callback
                            if (callback && callback.onUpdate) {
                                callback.onUpdate(registration);
                            }
                        }
                        else {
                            // At this point, everything has been precached.
                            // It's the perfect time to display a
                            // "Content is cached for offline use." message.
                            // tslint:disable-next-line
                            console.log("Content is cached for offline use.");
                            // Execute callback
                            if (callback && callback.onSuccess) {
                                callback.onSuccess(registration);
                            }
                        }
                    }
                };
            }
        };
    })
        .catch((error) => {
        // tslint:disable-next-line
        console.error("Error during service worker registration: ", error);
    });
}
function checkValidServiceWorker(swUrl, callback) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl)
        .then((response) => {
        // Ensure service worker exists, and that we really are getting a JS file.
        if (response.status === 404 ||
            (response.headers.get("content-type") || "").indexOf("javascript") ===
                -1) {
            // No service worker found. Probably a different app. Reload the page.
            navigator.serviceWorker.ready.then((registration) => {
                registration.unregister().then(() => {
                    window.location.reload();
                });
            });
        }
        else {
            // Service worker found. Proceed as normal.
            registerValidSW(swUrl, callback);
        }
    })
        .catch(() => {
        // tslint:disable-next-line
        console.log("No internet connection found. App is running in offline mode.");
    });
}
function unregister() {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.ready.then((registration) => {
            registration.unregister();
        });
    }
}
exports.unregister = unregister;
//# sourceMappingURL=serviceWorker.js.map